'use client'

import { ReactNode, startTransition, useCallback, useState, type JSX } from 'react'

import useAddEventListener from '@hooks/useAddEventListener'
import useIsomorphicEffect from '@hooks/useClientSideLayoutEffect'

import styles from './wrapper.module.scss'

type WrapperProps = {
  children: ReactNode
}

export default function Wrapper({ children }: WrapperProps): JSX.Element {
  const [scrollNavbar, setScrollNavbar] = useState<string>('')

  const handleScroll = useCallback((): void => {
    startTransition(() => {
      // 100 is height of navbar
      if (window.scrollY >= 1) {
        setScrollNavbar(styles.scrolled)
      } else {
        setScrollNavbar('')
      }
    })
  }, [])

  useAddEventListener('scroll', handleScroll)

  useIsomorphicEffect(() => {
    handleScroll()
  }, [])

  return <header className={`${styles.navbar} ${scrollNavbar} ${styles['navbar-to-blue']}`}>{children}</header>
}
